<div *ngIf="proofOfDelivery$ | async; let proofOfDelivery;"
     class="card-body pl-lg-4 pt-0 pt-lg-0 row align-items-center">
    <div [ngClass]="columnSize">
        <div [ngClass]="{'small': small}">
            <div *ngIf="!small">{{ 'common.comments' | translate }}: {{ proofOfDelivery.comments || '---' }}</div>
            <div *ngIf="proofOfDelivery.received_by_name">{{ 'common.name' | translate }}: {{ proofOfDelivery.received_by_name }}</div>
            <div *ngIf="proofOfDelivery.delivered_at">
                <ng-container *ngIf="dateFormat$ | async; let date_format">
                    {{ 'common.date' | translate }}: {{ proofOfDelivery.delivered_at | amLocal | amDateFormat: date_format || 'L' + ' LTS Z' }}
                </ng-container>
            </div>
        </div>
    </div>
    <div [ngClass]="columnSize" class="pt-3 pt-lg-0">
        <span>
            <img
                *ngIf="proofOfDelivery.signature"
                [src]="proofOfDelivery.signature"
                alt="{{ 'portal.ui.proof-of-delivery.failure-loading-signature' | translate }}"
                class="bg-light border-bottom border-dark d-flex align-items-center justify-content-center flex-column"
                [ngStyle]="{'min-width': small ? '100px': '300px', 'min-height': small ? '80px' : '200px', 'max-width': small ? '100px': '300px', 'max-height': small ? '80px' : '200px'}"
            />
            <div
                *ngIf="!proofOfDelivery.signature"
                class="bg-light border-bottom border-dark d-flex align-items-center justify-content-center flex-column p-3"
                style="width: 300px; height: 200px"
            >
                <fa-stack size="lg">
                    <fa-icon [icon]="['far', 'signature']" stackItemSize="1x"></fa-icon>
                    <fa-icon [icon]="['far', 'ban']" class="text-danger" stackItemSize="2x"></fa-icon>
                </fa-stack>
                <div>{{ 'portal.ui.proof-of-delivery.signature-not-available' | translate }}</div>
            </div>
        </span>
        <div class="small">{{ 'common.signature' | translate }}</div>
    </div>
</div>

<div *ngIf="routerLink" class="card-body pt-0">
    <button [ngClass]="{'btn-sm': small}" [queryParams]="routerLinkQueryParams" [routerLink]="routerLink"
            class="btn btn-primary">
        {{ 'common.view' | translate }}
    </button>
</div>
